export const leadFormStyles = (fontColor, font) => ({
    fontFamily: {
        fontFamily: `${font} !important`,
        '& *': {
            fontFamily: `${font} !important`
        }
    },
    title: {
        textAlign: 'center',
        paddingBottom: 20
    },
    popupIndicator: {
        color: fontColor
    },
    outlinedInput: {
        '&.MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: fontColor
            },
            '&:hover fieldset': {
                borderColor: fontColor
            },
            '&.Mui-focused fieldset': {
                borderColor: fontColor
            }
        }
    },
    inputLabel: {
        color: fontColor,
        fontFamily: `${font} !important`,
        '&.Mui-focused': {
            color: fontColor
        },
        '& .MuiFormLabel-asterisk': {
            fontFamily: `${font} !important`,
            color: fontColor,
            '&.Mui-error': {
                color: 'red'
            }
        }
    },
    inputText: {
        color: fontColor
    },
    datePickerInput: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: fontColor
            },
            '&:hover fieldset': {
                borderColor: fontColor
            },
            '&.Mui-focused fieldset': {
                borderColor: fontColor
            }
        },
        '& .MuiInputBase-input': {
            color: fontColor
        },
        '& .MuiInputLabel-root': {
            color: fontColor
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: fontColor
        },
        '& .MuiIconButton-root': {
            color: fontColor
        }
    },
    checkboxLabel: {
        fontFamily: `${font} !important`,
        color: fontColor
    },
    checkboxRoot: {
        color: fontColor,
        '&.Mui-checked': {
            color: fontColor
        },
        paddingTop: 2,
        paddingBottom: 2
    },
    textArea: {
        width: '100%',
        fontFamily: `${font} !important`,
        padding: 8,
        borderRadius: 4,
        border: `1px solid ${fontColor}`,
        fontSize: 16,
        color: fontColor,
        boxSizing: 'border-box',
        outline: 'none',
        '&:focus': {
            border: `1px solid ${fontColor}`
        }
    }
});
